<template>
  <section id="card-text-alignment">
    <b-card title="Filtros">
      <p v-if="pedidoFiltro" class="text-muted">
        Notas fiscais do pedido <strong>{{ pedidoFiltro }}</strong>
        <span v-if="$route.query.etapaPedido"> — {{ $route.query.etapaPedido === 'original' ? 'Original' : $route.query.etapaPedido }}</span>.
        Use “Limpar” para consultar outros pedidos.
      </p>
      <b-row class="filters-row">
        <b-col  cols="4">
          <b-form-group
              label="ESTAB.:"
              label-for="ESTAB.:"
          >
            <b-form-select
                id="estab"
                v-model="selected"
                :options="options"
                :value="options.value"
                :disabled="options.disabled"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
              label="NÚMERO NF:"
              label-for="numero-nf"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="" />
              </b-input-group-prepend>
              <b-form-input
                  id="numero-nf"
                  placeholder="Número NF"
                  v-model="items.notafiscalnumero"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group
              label="Série NF:"
              label-for="serie-nf"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="" />
              </b-input-group-prepend>
              <b-form-input
                  id="serie-nf"
                  placeholder="Série NF"
                  v-model="items.notafiscalserie"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col  cols="4">
          <b-form-group
              label="DE:"
              label-for="de"
          >
            <b-form-datepicker
                local="pt-BR"
                v-model="items.de"
                class="mb-2"
                today-variant="danger"
                placeholder="dd/mm/aaaa"
                hide-header
                dark
                initial-date="2022-12-20"
                date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                value="2022-12-20"
                weekday-header-format="narrow"
            />
          </b-form-group>
        </b-col>
        <b-col  cols="4">
          <b-form-group
              label="ATÉ:"
              label-for="ate"
          >
            <b-form-datepicker
                id="datepicker-default-2"
                v-model="items.ate"
                local="pt-BR"
                class="mb-2"
                today-variant="danger"
                placeholder="dd/mm/aaaa"
                hide-header
                dark
                initial-date="2021-01-01"
                date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                value="2021-01-01"
                weekday-header-format="narrow"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2">
          <b-button-group>
            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="primary"
                @click="filters('filter')"
            >
              Filtrar
            </b-button>
            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                @click="limpar()"
            >
              Limpar
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>
      <br>
      <b-overlay :show="$store.getters['PTC_NotasClient/getIsLoading']">
      <b-table
          :striped="true"
          :bordered="true"
          :hover="true"
          :responsive="true"
          table-variant="secondary"
          :per-page="perPage"
          :current-page="currentPage"
          :fields="camposVisiveis"
          :items="getNotas"
          small
          show-empty
          empty-text="Nenhum registro encontrado"
      >
        <!-- A virtual column -->
        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>

        <template #cell(notafiscaldtentregacliente)="data">
          {{ formatDate(data.item.notafiscaldtentregacliente) }}
        </template>

        <template #cell(action)="data">
          <div
              class="d-flex"
              style="gap:5px"
          >
            <!-- <b-button
              v-ripple.400="'rgba(40, 199, 111, 0.15)'"
              title="Danfe"
              variant="success"
              @click="danfe(data.item)"
              :disabled="loadingStates[getDanfeKey(data.item)]"
            >
              <span class="d-flex align-items-center">
                <b-spinner v-if="loadingStates[getDanfeKey(data.item)]" small />
                <feather-icon icon="FileTextIcon"/>
              </span>
            </b-button> -->
            <b-button
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                variant="success"
                title="Copiar dados da nota fiscal"
                @click="copiarDados(data.item)"
            >
              <feather-icon icon="FileTextIcon"/>
            </b-button>
            <b-button
                v-ripple.400="'rgba(255, 159, 67, 0.15)'"
                variant="warning"
                title="Boleto"
                @click="boleto(data.item)"
            >
              <feather-icon icon="BoldIcon"/>
            </b-button>
            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="primary"
                title="Visualizar DANFE (PDF)"
                :disabled="loadingStates[getDanfeKey(data.item)]"
                @click="verDocumento(data.item, 'ver')"
            >
              <span class="d-flex align-items-center">
                <b-spinner v-if="loadingStates[getDanfeKey(data.item)]" small />
                <feather-icon v-else icon="EyeIcon"/>
              </span>
            </b-button>
            <!-- Download XML oculto temporariamente.
            <b-button
                v-ripple.400="'rgba(130, 134, 139, 0.15)'"
                variant="secondary"
                title="Baixar arquivo fiscal da nota"
                aria-label="Baixar arquivo fiscal da nota"
                :disabled="loadingStates[getDanfeKey(data.item)]"
                @click="verDocumento(data.item, 'xml')"
            >
              <feather-icon icon="DownloadIcon"/>
            </b-button>
            -->
            <!-- <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="primary"
                title="Ocorrências de transporte"
                :to="{ name: 'ocorrenciasTransporte' }"
            >
              <feather-icon icon="CalendarIcon"/>
            </b-button> -->
          </div>
        </template>
      </b-table>
      </b-overlay>
      <b-row>
        <b-col sm="5" md="4" class="my-1">
          <b-form-group
              label="paginação"
              label-for="per-page-select"
              label-cols-sm="6"
              label-cols-md="4"
              label-cols-lg="3"
              label-align-sm="right"
              label-size="sm"
              class="mb-0"
          >
            <b-form-select
                id="per-page-select"
                v-model="perPage"
                :options="pageOptions"
                size="sm"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col sm="7" md="6" class="my-1">
          <b-pagination
              v-model="currentPage"
              :total-rows="getNotas.length"
              :per-page="perPage"
              align="fill"
              size="sm"
              class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
  </section>
</template>

<script>
import {
  VBTooltip, BButton, BFormSelect, BSpinner, BOverlay,
} from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';
import PTC_NotasService from '@/services/PTC/PTC_Notas.service';
import DocumentoFiscalClient, { baixarBase64, abrirPdfNovaAba } from '@/api/SistemaDKP/documento-fiscal.client';
import { mapGetters } from 'vuex';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';
import { isPerfilClienteAtivo } from '@/libs/perfilCliente';

const ptc_notasService = new PTC_NotasService();
const documentoFiscalClient = new DocumentoFiscalClient();

export default {
  components: {
    BFormSelect,
    BButton,
    BSpinner,
    BOverlay,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      dataDash: this.$route.params.dataDash || null,
      fields: [
        { key: 'nomeEstabelecimento', label: 'Estabelecimento' },
        { key: 'clienteiderp', label: 'Cliente' },
        { key: 'notafiscalserie', label: 'Série' },
        { key: 'notafiscalnumero', label: 'Nro NF' },
        // Relacionamento NF ↔ pedido ↔ OC do cliente (pedido do portal quando
        // existir; senão o nº de pedido que veio na própria NF do ERP).
        {
          key: 'pedidonumerocliente',
          label: 'Pedido',
          formatter: (v, k, item) => v || item.nr_ped_cli || '-',
        },
        { key: 'pedidooccliente', label: 'OC Cliente', formatter: (v) => v || '-' },
        { key: 'notafiscaldtemissao', label: 'Data Emissão' },
        { key: 'notafiscalvalortotal', label: 'Valor Original' },
        { key: 'notafiscaldtsaidaentrega', label: 'Data Saída' },
        { key: 'notafiscaldtentregacliente', label: 'Data Entrega' },
        { key: 'notafiscaltransportadoraid1', label: 'Transportadora' },
        // {key: 'notafiscaltransportadoraid2', label: 'Transport. Redespacho'},
        { key: 'action', label: 'Ações' },

      ],
      items: {
        notafiscalnumero: null,
        notafiscalserie: null,
        de: null,
        ate: null,
      },
      selected: null,
      options: [
        { value: null, text: '--Selecionar--', disabled: true },
      ],
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
      loadingStates: {},
      danfeLoading: false,
    };
  },
  methods: {
    formatDate(date) {
      if (!date) return '-';
      const d = new Date(date);
      d.setDate(d.getDate() - 1);
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    },
    async listNotas() {
      await ptc_notasService.retornaNotas();
    },
    async boleto(item) {
      this.$router.push({
        name: 'boleto',
        params: {
          notafiscalnumero: item.notafiscalnumero,
        },
      });
    },
    async filters() {
      const query = this.pedidoFiltro ? this.filtroPedidoFiscal : {};

      if (this.selected !== null) {
        query.estabelecimentoid = this.selected;
      }

      if (this.items.notafiscalnumero !== null && this.items.notafiscalnumero !== '') {
        query.notafiscalnumero = this.items.notafiscalnumero;
      }

      if (this.items.notafiscalserie !== null && this.items.notafiscalserie !== '') {
        query.notafiscalserie = this.items.notafiscalserie;
      }

      if (this.items.de !== null && this.items.de !== '') {
        if (this.items.ate === null || this.items.ate === '') {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Atenção',
              text: 'Preencha o campo "ATÉ" quando "DE" estiver preenchido.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          return;
        }
        query.DataEmissaoDe = this.items.de;
        query.DataEmissaoAte = this.items.ate;
      }

      if (this.items.ate !== null && this.items.ate !== '') {
        if (this.items.de === null || this.items.de === '') {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Atenção',
              text: 'Preencha o campo "DE" quando "ATÉ" estiver preenchido.',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
          return;
        }
        query.DataEmissaoDe = this.items.de;
        query.DataEmissaoAte = this.items.ate;
      }
      await ptc_notasService.retornaNotas(Object.keys(query).length ? query : null);
    },
    async limpar() {
      this.selected = null;
      this.numero_nf = null;
      this.items.notafiscalnumero = null;
      this.items.notafiscalserie = null;
      this.dataDash = null;
      this.items.de = '';
      this.items.ate = '';
      this.currentPage = 1;
      if (this.$route.query.notafiscalnumero || this.$route.query.pedidoid) {
        const query = { ...this.$route.query };
        delete query.notafiscalnumero;
        delete query.pedidoid;
        delete query.etapaPedido;
        await this.$router.replace({
          name: this.$route.name,
          params: this.$route.params,
          query,
        }).catch(() => {});
      }
      await ptc_notasService.retornaNotas();
    },
    getDanfeKey(item) {
      return `${item.estabelecimentoid}-${item.notafiscalnumero}-${item.notafiscalserie}`;
    },
    async verDocumento(item, modo) {
      const key = this.getDanfeKey(item);
      this.$set(this.loadingStates, key, true);
      try {
        // Always authorize against the current tenant/user; no session-global PDF cache.
        const docs = await documentoFiscalClient.danfeBoleto({
          estabelecimentoid: item.estabelecimentoid,
          notafiscalserie: item.notafiscalserie,
          notafiscalnumero: item.notafiscalnumero,
        });
        const numero = String(docs?.notaFiscal || item.notafiscalnumero);
        if (modo === 'xml') {
          if (!docs?.arquivoXML) throw new Error('XML não disponível para esta nota.');
          baixarBase64(docs.arquivoXML, `nf_${numero}.xml`, 'application/xml');
        } else if (modo === 'pdf') {
          if (!docs?.arquivoPDF) throw new Error('PDF não disponível para esta nota.');
          baixarBase64(docs.arquivoPDF, `danfe_${numero}.pdf`, 'application/pdf');
        } else {
          if (!docs?.arquivoPDF) throw new Error('PDF não disponível para esta nota.');
          abrirPdfNovaAba(docs.arquivoPDF);
        }
      } catch (error) {
        const msg = error?.response?.data?.message || error?.message || 'Erro ao buscar documentos da nota fiscal.';
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Erro',
            text: msg,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        });
      } finally {
        this.$set(this.loadingStates, key, false);
      }
    },
    async danfe(item) {
      const danfeKey = this.getDanfeKey(item);
      this.$set(this.loadingStates, danfeKey, true);

      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: 'Carregando',
          text: 'Carregando a Danfe. Aguarde',
          icon: 'LoaderIcon',
          variant: 'info',
        },
      },
      {
        timeout: 10000,
      });

      const query = {
        estabelecimentoid: item.estabelecimentoid,
        notafiscalnumero: item.notafiscalnumero,
        notafiscalserie: item.notafiscalserie,
      };

      const novaAba = window.open('', '_blank');

      try {
        const danfe = await ptc_notasService.retornaDanf(query);

        if (danfe) {
          novaAba.location.href = danfe;

          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Danfe gerada!',
              text: 'A Danfe foi aberta em uma nova aba!',
              icon: 'CheckIcon',
              variant: 'success',
            },
          });
        } else {
          novaAba.close();
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Erro',
              text: 'A Danfe não foi encontrada!',
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          });
        }
      } catch (error) {
        console.error('Erro ao obter DANFE:', error.message);
        novaAba.close();
        this.$toast.error('DANFE não disponível no momento. Tente novamente mais tarde.');
      } finally {
        this.$set(this.loadingStates, danfeKey, false);
      }
    },
    // async danfe(item) {
    //   try {
    //     const link = document.createElement('a');

    //     link.href = `/danfes/danfe_0000003_1.pdf`;

    //     link.download = `danfe_0000003_1.pdf`;

    //     // link.href = `/danfes/1-10-0342702-110225093807.pdf`;

    //     // link.download = `1-10-0342702-110225093807.pdf`;

    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    //   } catch (error) {
    //     this.$toast({
    //       component: ToastificationContent,
    //       position: 'top-right',
    //       props: {
    //         title: 'Erro',
    //         text: 'Erro ao fazer download da DANFE',
    //         icon: 'AlertTriangleIcon',
    //         variant: 'danger',
    //       },
    //     });
    //     console.error('Erro ao fazer download da DANFE:', error);
    //   }
    // },
    async downloadXml(item) {
      const query = {
        estabelecimentoid: item.estabelecimentoid,
        notafiscalnumero: item.notafiscalnumero,
        notafiscalserie: item.notafiscalserie,
      };

      console.log('NOTA FISCAL', query);

      try {
        const xml = await ptc_notasService.retornaXmlNota(query);
        const { type, data } = xml.byteXml;
        const blob = new Blob([new Uint8Array(data)], { type: 'application/xml' });

        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = `NF_${item.notafiscalnumero}.xml`;
        a.click();
      } catch (error) {
        console.error('Erro ao fazer download do arquivo XML', error.message);
      }
    },
    async copiarTexto(texto) {
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        await navigator.clipboard.writeText(texto);
        return;
      }

      const campoTemporario = document.createElement('textarea');
      campoTemporario.value = texto;
      campoTemporario.setAttribute('readonly', '');
      campoTemporario.style.position = 'fixed';
      campoTemporario.style.opacity = '0';
      campoTemporario.style.pointerEvents = 'none';
      document.body.appendChild(campoTemporario);

      try {
        campoTemporario.focus();
        campoTemporario.select();
        campoTemporario.setSelectionRange(0, campoTemporario.value.length);

        if (!document.execCommand('copy')) {
          throw new Error('O navegador recusou a cópia para a área de transferência');
        }
      } finally {
        document.body.removeChild(campoTemporario);
      }
    },
    async copiarDados(item) {
      try {
        const texto = `Série: ${item.notafiscalserie}\nNúmero: ${item.notafiscalnumero}\nEmissão: ${this.formatDate(item.notafiscaldtemissao)}\nValor total: ${item.notafiscalvalortotal}`;

        await this.copiarTexto(texto);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sucesso',
            text: 'Dados da nota fiscal copiados para área de transferência!',
            icon: 'CheckCircleIcon',
            variant: 'success',
          },
        });
      } catch (err) {
        console.error(err);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Falha ao copiar dados da nota fiscal. Tente novamente.',
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        });
      }
    },
  },
  async mounted() {
    const notaFiscalNumero = Array.isArray(this.$route.query.notafiscalnumero)
      ? this.$route.query.notafiscalnumero[0]
      : this.$route.query.notafiscalnumero;

    if (this.pedidoFiltro) {
      await ptc_notasService.retornaNotas(this.filtroPedidoFiscal);
    } else if (notaFiscalNumero) {
      this.items.notafiscalnumero = String(notaFiscalNumero);
      await ptc_notasService.retornaNotas({
        notafiscalnumero: this.items.notafiscalnumero,
      });
    } else if (this.dataDash !== null && this.dataDash !== '') {
      const { items } = this;
      items.de = this.dataDash.dataInicial;
      items.ate = this.dataDash.dataFinal;
      const query = {
        DataEmissaoDe: this.dataDash.dataInicial,
        DataEmissaoAte: this.dataDash.dataFinal,
      };
      await ptc_notasService.retornaNotas(query);
    } else {
      await this.listNotas();
    }
    const estabelecimentos = [];
    this.getNotas.forEach((nota) => {
      if (nota.estabelecimentoid && nota.nomeEstabelecimento) {
        if (!estabelecimentos.some((e) => e.value === nota.estabelecimentoid)) {
          estabelecimentos.push({
            value: nota.estabelecimentoid,
            text: nota.nomeEstabelecimento,
          });
        }
      }
    });
    this.options = [
      { value: null, text: '--Selecionar--', disabled: true },
      ...estabelecimentos,
    ];
  },
  computed: {
    filtroPedidoFiscal() {
      return { pedidoid: this.pedidoFiltro,
        ...(this.$route.query.etapaPedido !== undefined ? { etapaPedido: this.$route.query.etapaPedido } : {}) };
    },
    pedidoFiltro() {
      return this.$route.query.pedidoid || null;
    },
    ...mapGetters({
      getNotas: 'PTC_NotasClient/getNotas',
      getSelect: 'PTC_NotasClient/getSelect',
    }),
    isClienteAtivo() {
      return isPerfilClienteAtivo();
    },
    camposVisiveis() {
      if (!this.isClienteAtivo) return this.fields;
      return this.fields.filter((field) => field.key !== 'clienteiderp');
    },
  },
};
</script>
<style scoped lang="scss">
@media (max-width: 767.98px) {
  .filters-row > .col-4 {
    flex: 0 0 100%;
    max-width: 100%;
    margin-bottom: 0.5rem;
  }

  .filters-row > .col-4:last-child {
    margin-bottom: 0;
  }
}
</style>
